
export type ParentType = 'DAM' | 'SIRE'
export class ParentTypeValues {
static readonly   DAM: ParentType = 'DAM';
static readonly   SIRE: ParentType = 'SIRE';
};

